import { Component } from 'react'
import { processSilentRenew } from 'redux-oidc'

export class SilentRenewContainer extends Component {
  componentDidMount() {
    processSilentRenew()
  }

  render() {
    return null
  }
}

export default SilentRenewContainer
